export default "__VITE_ASSET__BLKz55I4__"